// extracted by mini-css-extract-plugin
module.exports = {"toggleInput":"toggleInput--2GVIT","sliderContainer":"sliderContainer--11AiW","checked":"checked--Yeaaf","slider":"slider--38PTn"};